import Information from './Information'

const OtherStandard = {
    Information,
}

export default OtherStandard
